import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService, AuthService, ScrollParams, ScrollService } from '../../api';
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as _ from 'lodash';
import {PlayerService} from '../../player/services/player.service';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit, OnDestroy {
  private account: any;
  private isCurrentUser: boolean = false;
  private playlists: Array<any> = new Array<any>();
  private userFollowings: Array<any> = new Array<any>();
  private likes: Array<any> = new Array<any>();
  private followers: Array<any> = new Array<any>();
  private currentTab: number = 0;
  private scrollParams: ScrollParams = new ScrollParams();
  private scrollSubscriber = null;
  private routeSub = null;
  uId:any;
  checkRadio = true;
  // to manage the multiple calls on scroll
  enableScrollForPlaylist = true;
  enableScrollForFollowing = false;
  enableScrollForFollowers = false;
  noRecordFound: boolean = false;
  constructor(private userService: UserService, private route: ActivatedRoute, private authService: AuthService,
    private scrollService: ScrollService, private router: Router, public playerService: PlayerService) {
  }

  ngOnInit() {
    this.routeSub = this.route.params.subscribe(params => {
      this.getUserDetails(params['screenname']);
    });
    this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) => this.getDashboardData(this.currentTab));
    // for logged in user, follow should not be visible
    this.uId = this.authService.getLoggedInUserId();
  }

  getUserDetails(screenname: any) {
    this.userService.getUserDetailsBySlug(screenname).subscribe((res: any) => {
      this.noRecordFound = false;
      this.account = res;
      this.playlists = new Array<any>();
      this.userFollowings = new Array<any>();
      this.likes = new Array<any>();
      this.followers = new Array<any>();
      if (typeof res.id !== 'undefined') {
        this.account = res;
        this.getDashboardData(0);
        if (this.account.id === this.authService.getLoggedInUserId()) {
          this.isCurrentUser = true;
        }
      } else {
        this.userService.getArchivedUserName(screenname).subscribe((data: any) => {
          if (typeof data.screenname !== 'undefined') {
            this.router.navigate(['/account/' + data.screenname]);
          }
        });
        this.noRecordFound = true;
      }
    });
  }

  getDashboardData(index) {
    if (!this.account || !this.account.id) {
      return false;
    }
    // for playlists tab
    if (index === 0 && this.enableScrollForPlaylist) {
      this.scrollService.toggleProgressBar(true);
      this.enableScrollForPlaylist = false;
      this.userService.loadUserPlaylist(this.scrollParams, this.account.id).subscribe((res) => {
        this.scrollService.toggleProgressBar(false);
        if (res.length > 0) {
          res.forEach((arrayItem) => {
            this.playlists.push(arrayItem);
            if (arrayItem.type == 'R' && this.checkRadio) {
              localStorage.setItem("radio", '1');
              localStorage.setItem("response", '1');
              setInterval(() => {
                if (localStorage.getItem("radio") == "1" && localStorage.getItem("response") == "1") {
                  this.playerService.checkRadio();
                  this.checkRadio = false;
                }
              }, 2500);
            }
          });
          this.playlists = _.uniqBy(this.playlists, 'id');
          this.scrollParams.page++;
          this.enableScrollForPlaylist = true;
        }
        if(res.length == 0 || res.length < 20) {
          // disable the scroll if no result exists to avoid the multiple calls
          this.enableScrollForPlaylist = false;
        }
      });
    }
    // for following tab
    if (index === 1 && this.enableScrollForFollowing) {
      this.scrollService.toggleProgressBar(true);
      this.enableScrollForFollowing = false;
      this.userService.loadUsersFollowing(this.scrollParams, this.account.id).subscribe((res) => {
        this.scrollService.toggleProgressBar(false);
        if (res.length > 0) {
          res.forEach((arrayItem) => {
            this.userFollowings.push(arrayItem);
          });
          this.userFollowings = _.uniqBy(this.userFollowings, 'id');
          this.scrollParams.page++;
          this.enableScrollForFollowing = false;
        }
        if(res.length == 0 || res.length < 20) {
          // disable the scroll if no result exists to avoid the multiple calls
          this.enableScrollForFollowing = false;
        }
      });
    }
    // for followers tab
    if (index === 2 && this.enableScrollForFollowers) {
      this.scrollService.toggleProgressBar(true);
      this.enableScrollForFollowers = false;
      this.userService.loadUserFollowers(this.scrollParams, this.account.id).subscribe((res) => {
        this.scrollService.toggleProgressBar(false);
        if (res.length > 0) {
          res.forEach((arrayItem) => {
            this.followers.push(arrayItem);
          });
          this.followers = _.uniqBy(this.followers, 'id');
          this.scrollParams.page++;
          this.enableScrollForFollowers = true;
        }
        if(res.length == 0 || res.length < 20) {
          // disable the scroll if no result exists to avoid the multiple calls
          this.enableScrollForFollowers = false;
        }
      });
    }

    if (index === 3) {
      this.userService.loadUsersLikes(this.scrollParams, this.account.id).subscribe((res) => {
        if (res.length > 0) {
          res.forEach((arrayItem) => {
            this.likes.push(arrayItem);
          });
          this.likes = _.uniqBy(this.likes, 'id');
          this.scrollParams.page++;
        }
        this.scrollService.toggleProgressBar(false);
      });
    }
  }

  tabChanged(event) {
    if (event.index == 0) {
      this.enableScrollForPlaylist = true;
      this.enableScrollForFollowing = false;
      this.enableScrollForFollowers = false;
    } else if (event.index == 1) {
      this.enableScrollForPlaylist = false;
      this.enableScrollForFollowing = true;
      this.enableScrollForFollowers = false;
    } else if (event.index == 2) {
      this.enableScrollForPlaylist = false;
      this.enableScrollForFollowing = false;
      this.enableScrollForFollowers = true;
    }
    this.currentTab = event.index;
    this.scrollParams = new ScrollParams();
    this.getDashboardData(event.index);
  }

  ngOnDestroy() {
    if (this.scrollSubscriber != null) {
      this.scrollSubscriber.unsubscribe();
    }
    if (this.routeSub !== null) {
      this.routeSub.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/user/user-detail/user-detail.component.ts